// In-memory preview-mode state machine. Lives outside React so it can be
// unit-tested without jsdom. The Workspace component holds one instance
// per mount and re-renders by separately calling React's setState whenever
// `enter` / `exit` is invoked.

export function createPreviewState() {
  let active = null;
  const cache = new Map();

  const key = (filePath, sha256) => `${filePath}\x00${sha256}`;

  return {
    enter(filePath, ver) {
      active = {
        filePath,
        versionId:    ver.versionId,
        sha256:       ver.sha256,
        committed_by: ver.committed_by,
        committed_at: ver.committed_at,
        content:      ver.content,
      };
      cache.set(key(filePath, ver.sha256), ver.content);
    },
    exit() {
      active = null;
    },
    get() {
      return active;
    },
    isCached(filePath, sha256) {
      return cache.has(key(filePath, sha256));
    },
    getCached(filePath, sha256) {
      return cache.get(key(filePath, sha256));
    },
  };
}
